























































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import NodeInput from '@/components/nodeComponent/NodeInput.vue';
import NodeLegend from '@/components/nodeComponent/NodeLegend.vue';
import NodeMenu from '@/components/nodeComponent/NodeMenu.vue';
import NodeLink from '@/components/nodeComponent/NodeLink.vue';
import {getCoordinatesSvgPoint, parseXmlToSvg} from '@u/svgUtils';
import draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
import Loading from '@c/controls/Loading.vue';
import {PModulePosition, PModuleWithCoords} from '@/views/system/modules/interfaces';
import {NodeData} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';
import {connectionConfigWorkStatus} from '@/api/configApi';
import serviceModule from '@/store/modules/entities/serviceModule';
import {getAllTasks} from '@/store/modules/entities/pmodules/pmoduleTasksModule';
import enumsModule from '@/store/modules/enumsModule';

@Component({
  components: {
    NodeInput,
    NodeLegend,
    NodeMenu,
    NodeLink,
    draggable,
    Loading,
  },
})
export default class NodeComponent extends Vue {
  loading = false;
  error = false;

  connectionWorkStatus: WebSocket | null = null;
  workStatuses = {};

  // Показатель режима просмотра
  @Prop({required: false, type: Boolean, default: false})
  showMode!: boolean;

  // Идентификатор узла
  @Prop({required: true})
  nodeId!: number;

  @Prop({required: false, type: Boolean, default: true})
  connect!: boolean;

  @Prop({required: false})
  boundaries: any;

  @Prop({required: false, type: Boolean, default: false})
  showServices!: boolean;

  key = 0;

  // Размеры viewBox для svg
  viewBoxSize = {width: 1000, height: 600};

  // Размеры nodeInput и nodeLink
  nodeInputSize = {width: 250, height: 24};

  inputData = [];
  legendData = [
    {color: 'green', text: 'активно'},
    {color: 'blue', text: 'неактивно'},
    {color: 'red', text: 'ошибка'},
    {color: 'black', text: 'другое'},
  ];
  basePModulesList: PModuleWithCoords[] = [];

  baseLinkList: NodeData[] = [];

  selectedPModule: PModuleWithCoords | null = null;

  selectedLink: NodeData | null = null;

  editFlag = false;

  newPModules: PModuleWithCoords[] = [];

  newLinks: NodeData[] = [];

  nodeServices: any[] = [];
  oilNodes: any[] = [];

  // перемещаемый на SVG узел
  draggableItem: PModuleWithCoords | NodeData | null = null;

  // добавляемый на SVG узел
  addedItem: any | null = null;

  // смещение координат SVG относительно координат клиентской области приложения
  offsetX!: number;
  offsetY!: number;

  // сохраненные первоначальные координаты узлов
  savedCoordinates: {
    id?: number | string;
    coords?: {x: number; y: number} | null;
    name?: string;
  }[] = [];

  // при перетаскивании скрываем тултип
  showTooltip = true;

  errorString = '';

  get xsOnly() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  // при переходе от списка к svg грузим заново схему
  @Watch('xsOnly')
  async onResized(value: any) {
    if (value) return;

    try {
      this.loading = true;
      this.error = false;
      await this.drawScheme();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  get showLegend() {
    return this.nodeData.length > 0;
  }

  get nodeLinks() {
    const existingLink = this.baseLinkList.filter(
      (item: NodeData) => item.id && item.coords && !this.searchLink(this.newLinks, item.id),
    );
    const existingLinkChanges = this.newLinks.filter((item: NodeData) => item.coords);
    return [...existingLink, ...existingLinkChanges];
  }

  get nodeData() {
    const existingNode = this.basePModulesList.filter(
      (item: PModuleWithCoords) =>
        item.guid &&
        item.coords &&
        !this.searchPModule(this.newPModules, item.guid) &&
        item.nodes &&
        item.nodes.filter((pos: PModulePosition) => pos.node_id == this.nodeId).length > 0,
    );
    const existingNodeChanges = this.newPModules.filter((item: PModuleWithCoords) => item.coords);
    return [...existingNode, ...existingNodeChanges];
  }

  get availableNode() {
    return this.basePModulesList.filter((item: PModuleWithCoords) => {
      if (!item.guid) return false;
      const changeItem = this.searchPModule(this.newPModules, item.guid);
      return changeItem ? !changeItem.coords : !item.coords;
    });
  }

  get placedNode() {
    return this.basePModulesList.filter((item: PModuleWithCoords) => {
      if (!item.guid) return false;
      const changeItem = this.searchPModule(this.newPModules, item.guid);
      return changeItem ? changeItem.coords : item.coords;
    });
  }

  get availableLink() {
    return this.baseLinkList.filter((item: NodeData) => {
      if (!item.id) return false;
      const changeItem = this.searchLink(this.newLinks, item.id);
      return changeItem ? !changeItem.coords : !item.coords;
    });
  }

  get pModulesIds() {
    return this.basePModulesList.map((item: {guid?: string}) => item.guid as string);
  }

  @Watch('editFlag')
  watchEditFlag(flag: boolean) {
    if (!flag) {
      this.selectedPModule = null;
      this.selectedLink = null;
      this.key++;
      this.newPModules = [];
      this.newLinks = [];
      this.savedCoordinates = [];
    }
  }

  async mounted() {
    let allTasks: any[] = [];
    try {
      allTasks = await getAllTasks();
    } catch {
      console.log('Cannot load all tasks');
    }
    try {
      this.loading = true;
      this.error = false;
      await nodeModule.fetchAll();
      this.baseLinkList = await nodeModule.getChildNodes(this.nodeId);
      if (this.baseLinkList !== undefined) {
        for (let i = 0; i < this.baseLinkList.length; i++) {
          this.baseLinkList[i].children = await nodeModule.getChildNodes(
            this.baseLinkList[i].id as number,
          );
          if (this.baseLinkList[i]?.children !== undefined) {
            for (let j = 0; j < (this.baseLinkList[i]?.children?.length as number); j++) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore: Object is possibly 'undefined'.
              this.baseLinkList[i].children[j].children = await nodeModule.getChildNodes(
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore: Object is possibly 'undefined'.
                this.baseLinkList[i].children[j].id as number,
              );
            }
          }
        }
      }
      this.basePModulesList = await nodeModule.getModules(this.nodeId);

      await serviceModule.fetchAll();
      const services = [...serviceModule.all].filter(
        service => service.name !== 'facility_structure',
      );

      const {data} = await nodeModule.edit(this.nodeId);
      if (data.services) {
        data.services.forEach((service: any) => {
          const guids = service.modules.reduce((arr: any, el: any) => {
            return arr.concat([...el.guids]);
          }, []);

          const moduleNames = guids.map((guid: string) => {
            const pmodule = allTasks.filter(m => m.guid === guid)[0];
            return {type: pmodule?.type, name: pmodule ? pmodule.name : guid, id: pmodule?.id};
          });

          this.nodeServices.push({
            name: services.find(x => x.name == service.name)?.description,
            data: moduleNames,
          });
        });
      }
      this.oilNodes = data.oil;
    } catch (e) {
      console.log('NodeComponent.mounted failed:', e);
      this.error = true;
    } finally {
      await this.drawScheme();
      this.loading = false;
    }
  }

  created() {
    if (this.connect) this.connectionWorkStatus = connectionConfigWorkStatus();
    if (this.connectionWorkStatus) {
      this.connectionWorkStatus.onmessage = (e: {data: string}) => {
        this.workStatuses = JSON.parse(e.data as any);
      };
    }
  }

  beforeDestroy() {
    if (this.connectionWorkStatus)
      if (this.connectionWorkStatus.readyState === WebSocket.OPEN)
        this.closeConnection(this.connectionWorkStatus);
      else this.connectionWorkStatus.onopen = this.waitForCloseWorkStatus;
  }

  waitForCloseWorkStatus() {
    if (this.connectionWorkStatus) {
      this.closeConnection(this.connectionWorkStatus);
    }
  }

  closeConnection(socket: WebSocket | null) {
    if (socket) {
      socket.close();
      socket = null;
    }
  }

  getNodeBackgroundColor(id: any) {
    if (!this.boundaries || !this.boundaries.length) return '';
    const boundary = this.boundaries.find((x: any) => x.id == id).boundary;
    if (boundary == -3) return 'purple';
    else if (boundary == -2) return 'blue';
    else if (boundary == -1) return 'cyan';
    else if (boundary == 0) return '#311b92';
    else if (boundary == 1) return 'yellow';
    else if (boundary == 2) return 'orange';
    else if (boundary == 3) return 'red';
    else return '';
  }

  getNodeColor(id: any) {
    if (!this.boundaries || !this.boundaries.length) return '';
    const boundary = this.boundaries.find((x: any) => x.id == id).boundary;
    if (boundary < 1) return 'white';
    else return 'black';
  }

  // Рисуем схему узла
  async drawScheme() {
    const data = await nodeModule.getScheme(this.nodeId);
    if (data) {
      const doc = parseXmlToSvg(data);
      const container = this.$el.querySelector('#scheme');
      const svgElement = this.removeSvgSizeAttributes(doc.documentElement);
      container?.appendChild(svgElement);
    }
  }

  /*
    Удаляет с svg атрибуты width и height
    svg без атрибутов width и height, но с указанным атрибутом viewBox подстраивается под размеры внешней svg
  */
  removeSvgSizeAttributes(svgElement: HTMLElement) {
    svgElement.removeAttribute('width');
    svgElement.removeAttribute('height');
    return svgElement;
  }

  async updateNodePModules() {
    this.basePModulesList = await nodeModule.getModules(this.nodeId);
  }

  searchPModule(pModules: PModuleWithCoords[], guid: string) {
    return pModules.find((item: PModuleWithCoords) => item.guid === guid);
  }

  searchLink(links: NodeData[], id: number) {
    return links.find((item: NodeData) => item.id === id);
  }

  onSelectPModuleToSet(item: PModuleWithCoords) {
    this.selectedPModule = item;
  }

  onSelectLinkToSet(link: NodeData) {
    this.selectedLink = link;
  }

  onChangeEditFlag(flag: boolean) {
    this.editFlag = flag;
    if (this.editFlag) {
      this.savedCoordinates.push(
        ...this.nodeData.map((item: PModuleWithCoords) => {
          const coords = cloneDeep(item.coords);
          return {id: item.guid, coords, name: item.name};
        }),
      );

      this.savedCoordinates.push(
        ...this.nodeLinks.map((item: NodeData) => {
          const coords = cloneDeep(item.coords);
          return {id: item.id, coords, name: item.name};
        }),
      );
    }
  }

  // Нажата кнопка отмена, возвращаем исходные координаты
  onClickCancel(flag: boolean) {
    this.editFlag = flag;

    this.basePModulesList.map((item: PModuleWithCoords) => {
      const saved = this.savedCoordinates.find(x => x.id === item.guid);
      if (saved?.coords) item.coords = {x: saved.coords.x, y: saved.coords.y};
    });

    this.baseLinkList.map((item: NodeData) => {
      const saved = this.savedCoordinates.find(x => x.id === item.id);
      if (saved?.coords) item.coords = {x: saved.coords.x, y: saved.coords.y};
    });
  }

  async updatePModules() {
    const updatePModules = this.nodeData
      .filter(
        (item: PModuleWithCoords) => item.guid && !this.searchPModule(this.newPModules, item.guid),
      )
      .concat(this.newPModules);

    const filteredModules = this.basePModulesList
      .filter(
        x =>
          !updatePModules.some(y => x.guid == y.guid) &&
          x.nodes &&
          x.nodes.filter((pos: PModulePosition) => pos.node_id == this.nodeId).length > 0,
      )
      .map(x => ({guid: x.guid as string, x: x.coords?.x, y: x.coords?.y}));

    const modules = updatePModules
      .map(x => ({
        guid: x.guid as string,
        x: x.coords?.x,
        y: x.coords?.y,
      }))
      .concat(filteredModules);

    await nodeModule.batchSetModules({
      id: this.nodeId,
      modules,
    });

    this.basePModulesList = this.basePModulesList.map((item: PModuleWithCoords) => {
      if (!item.guid) return item;
      const updatePModule = this.searchPModule(updatePModules, item.guid);
      if (updatePModule) return {...item, coords: updatePModule.coords};
      return item;
    });
    this.editFlag = false;
  }

  async updateLinks() {
    const updateLinks = this.nodeLinks
      .filter((item: NodeData) => item.id && !this.searchLink(this.newLinks, item.id))
      .concat(this.newLinks);

    await nodeModule.batchUpdateNodes({
      id: this.nodeId,
      nodes: updateLinks.map(x => ({
        id: x.id as number,
        x: x.coords?.x,
        y: x.coords?.y,
      })),
    });

    this.baseLinkList = this.baseLinkList.map((item: NodeData) => {
      if (!item.id) return item;
      const updateLink = this.searchLink(updateLinks, item.id);
      if (updateLink) return {...item, coords: updateLink.coords};
      return item;
    });
    this.editFlag = false;
  }

  async updateScheme(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const data = await nodeModule.uploadScheme({id: this.nodeId, formData});
      const doc = parseXmlToSvg(data);
      const container = this.$el.querySelector('#scheme');
      const child = container?.querySelector('svg');
      if (child) container?.removeChild(child as Node);
      const svgElement = this.removeSvgSizeAttributes(doc.documentElement);
      container?.appendChild(svgElement);
    } catch (e) {
      this.error = false; //скрываем сообщение об ошибке отрисовки схемы, чтобы разместить на его месте новое
      if (e?.response.status === 500) {
        this.errorString = 'Ошибка на стороне сервера';
      } else if (e?.response.status === 413) {
        this.errorString = 'Слишком большой объем загружаемого файла';
      } else {
        console.log(e);
        this.errorString = 'Ошибка загрузки файла';
        console.log('Ошибка загрузки файла');
      }
    }
  }

  onClickSvg(evt: MouseEvent) {
    if (!(this.editFlag || this.selectedPModule || this.selectedLink)) {
      if (this.nodeData.length == 0) return;
      const {href} = this.$router.resolve({
        name: 'nodeSensorsView',
        params: {id: `${this.nodeId}`},
      });
      window.open(href, '_blank');
      return;
    }

    const svg = this.$el.querySelector('#svg') as SVGSVGElement;
    const {clientX, clientY} = evt;
    const coords = getCoordinatesSvgPoint(svg, clientX, clientY);

    if (this.selectedPModule && this.selectedPModule.guid) {
      const existInNewPModules = this.searchPModule(this.newPModules, this.selectedPModule.guid);
      if (existInNewPModules) {
        existInNewPModules.coords = {...coords};
      } else this.newPModules.push({...this.selectedPModule, coords});
      this.selectedPModule = null;
    }

    if (this.selectedLink && this.selectedLink.id) {
      const existInNewLinks = this.searchLink(this.newLinks, this.selectedLink.id);
      if (existInNewLinks) {
        existInNewLinks.coords = {...coords};
      } else this.newLinks.push({...this.selectedLink, coords});
      this.selectedLink = null;
    }
  }

  onDeletePModule(item: PModuleWithCoords) {
    if (!this.editFlag || !item.guid) return;
    const itemInExistingNode = this.searchPModule(this.basePModulesList, item.guid);
    let itemInChangesNode = this.searchPModule(this.newPModules, item.guid);

    if (!itemInChangesNode && itemInExistingNode && itemInExistingNode.coords) {
      const copyItem = {...itemInExistingNode};
      this.newPModules.push(copyItem);
      itemInChangesNode = copyItem;
    }

    if (itemInChangesNode) itemInChangesNode.coords = undefined;
  }

  onDeleteLink(item: NodeData) {
    if (!this.editFlag || !item.id) return;

    const itemInExistingNode = this.searchLink(this.baseLinkList, item.id);
    let itemInChangesNode = this.searchLink(this.newLinks, item.id);

    if (!itemInChangesNode && itemInExistingNode && itemInExistingNode.coords) {
      const copyItem = {...itemInExistingNode};
      this.newLinks.push(copyItem);
      itemInChangesNode = copyItem;
    }
    if (itemInChangesNode) itemInChangesNode.coords = undefined;
  }

  onLinkClick(item: NodeLink) {
    if (this.editFlag) return;
    this.$emit('linkClick', item);
  }

  // запоминаем перетаскиваемый узел, запоминаем смещение координат клиентской области относительно svg, а также переносим элемент в конец списка, чтобы на svg "z-index" у него был больше
  startDrag(evt: any, item: PModuleWithCoords | NodeData) {
    if (!this.editFlag) return;
    if (!item?.coords) return;
    this.draggableItem = item;

    // TODO: исправить Александру!
    // Нужен рефакторинг
    let index = -1;
    if ((item as any).guid) {
      let index = this.newPModules.findIndex((elem: any) => elem.guid == (item as any).guid);
      if (index !== -1) this.newPModules.push(this.newPModules.splice(index, 1)[0]);

      index = this.basePModulesList.findIndex((elem: any) => elem.guid == (item as any).guid);
      if (index !== -1) this.basePModulesList.push(this.basePModulesList.splice(index, 1)[0]);
    } else {
      index = this.newLinks.findIndex((elem: any) => elem.id === item.id);
      if (index !== -1) this.newLinks.push(this.newLinks.splice(index, 1)[0]);

      index = this.baseLinkList.findIndex((elem: any) => elem.id === item.id);
      if (index !== -1) this.baseLinkList.push(this.baseLinkList.splice(index, 1)[0]);
    }

    if (item.coords) {
      const svg = this.$el.querySelector('#svg') as SVGSVGElement;
      const {clientX, clientY} = evt;
      const coords = getCoordinatesSvgPoint(svg, clientX, clientY);
      this.offsetX = item.coords.x - coords.x;
      this.offsetY = item.coords.y - coords.y;
      this.showTooltip = false;
    }
  }

  stopDrag() {
    this.draggableItem = null;
    this.showTooltip = true;
  }

  // при перемещении узла на SVG получаем его новые координаты на SVG
  doDrag(evt: any) {
    if (this.draggableItem?.coords) {
      const svg = this.$el.querySelector('#svg') as SVGSVGElement;
      const {clientX, clientY} = evt;
      const coords = getCoordinatesSvgPoint(svg, clientX, clientY);
      this.draggableItem.coords.x = coords.x + this.offsetX;
      this.draggableItem.coords.y = coords.y + this.offsetY;
    }
  }

  // перетаскивание добавляемого узла из меню на SVG
  onItemMove(evt: any) {
    this.addedItem = evt;
  }

  // по завершению перетаскивания добавляемого узла из меню на SVG добавляем в новые узлы и вычисляем его координаты на SVG
  onDragEndPModule(item: PModuleWithCoords) {
    if (!item.guid) return;
    const svg = this.$el.querySelector('#svg') as SVGSVGElement;
    const coords = getCoordinatesSvgPoint(
      svg,
      this.addedItem.originalEvent.clientX,
      this.addedItem.originalEvent.clientY,
    );

    const existInNewPModules = this.searchPModule(this.newPModules, item.guid);
    if (existInNewPModules) {
      existInNewPModules.coords = {...coords};
    } else this.newPModules.push({...item, coords});
    this.addedItem = null;
  }

  onDragEndLink(item: NodeData) {
    if (!item.id) return;
    const svg = this.$el.querySelector('#svg') as SVGSVGElement;
    const coords = getCoordinatesSvgPoint(
      svg,
      this.addedItem.originalEvent.clientX,
      this.addedItem.originalEvent.clientY,
    );
    const existInNewLinks = this.searchLink(this.newLinks, item.id);
    if (existInNewLinks) {
      existInNewLinks.coords = {...coords};
    } else this.newLinks.push({...item, coords});
    this.addedItem = null;
  }

  editTask(task: any) {
    const currentModule = enumsModule.moduleTypes.filter(v => v.value === task.type);
    this.$router.push({
      name: 'EditMonitor',
      params: {id: `${task.id}`, type: currentModule[0].url},
    });
  }

  viewOilNode(id: any) {
    this.$router.push({
      name: 'OilReport',
      params: {oid: `${id}`},
    });
  }
}
